const style = {
  buttonStyle: {
    display: "flex",
    gap: 16,
    justifyContent: "end",
  },
  typographyStyle: {
    color: "#525252",
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: "Noto Sans",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
  },
  spanStyle: {
    color: "#F00",
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: "Noto Sans",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
  },
  dateStyle: {
    border: "1px solid #897c6f ",
    padding: "5px 5px",
    display: "flex",
    alignItems: "center",
  },
  textFieldStyle: {
    width: "100%",
  },
  attachmentsLists: {
    background: "#f5f5f5",
  },
  attachmentsListsItems: {
    display: "flex",
    alignItems: "center",
    color: "#15c",
    cursor: "pointer",
  },
};

export default style;
